import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import LoginPage from "./pages/Login/LoginPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import PickupQueuePage from "./pages/PickupQueue/PickupQueuePage";
import TodaysListingPage from "./pages/TodaysListing/TodaysListingPage";
import OrderDetailPage from "./pages/OrderDetail/OrderDetailPage";
import OrdersPage from "./pages/Orders/OrdersPage";
import ProductFormPage from "./pages/ProductForm/ProductFormPage";
import OutletProductPage from "./pages/OutletProduct/OutletProductPage";
import ProfilePage from "./pages/Profile/ProfilePage";
import ReportPage from "./pages/Report/ReportPage";
import SalesReportPage from "./pages/Report/SalesReportPage";
import OrderPerformancePage from "./pages/Report/OrderPerformancePage";
import ListingPerformancePage from "./pages/Report/ListingPerformancePage";
import StaffManagementPage from "./pages/StaffManagement/StaffManagementPage";
import StaffFormPage from "./pages/StaffForm/StaffFormPage";
import RoleManagementPage from "./pages/RoleManagement/RoleManagementPage";
import ProtectedRoute from "./components/ProtectedRoute";
import PermissionRoute from "./components/PermissionRoute";
import AppLayout from "./components/AppLayout/AppLayout";
import { isMerchantAuthenticated } from "./api/merchantAuthApi";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          path="/"
          element={
            <ProtectedRoute isAuthenticated={isMerchantAuthenticated()}>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="pickup-queue" element={<PermissionRoute permission="pickup_queue_view"><PickupQueuePage /></PermissionRoute>} />
          <Route path="todays-listing" element={<PermissionRoute permission="todays_availability_view"><TodaysListingPage /></PermissionRoute>} />
          <Route path="orders" element={<PermissionRoute permission="orders_view"><OrdersPage /></PermissionRoute>} />
          <Route path="orders/:orderNo" element={<PermissionRoute permission="orders_view"><OrderDetailPage /></PermissionRoute>} />
          <Route path="outlet-products" element={<PermissionRoute permission="product_view"><OutletProductPage /></PermissionRoute>} />
          <Route path="products/create" element={<PermissionRoute permission="product_update"><ProductFormPage mode="create" /></PermissionRoute>} />
          <Route path="products/:productId/edit" element={<PermissionRoute permission="product_update"><ProductFormPage mode="edit" /></PermissionRoute>} />
          <Route path="reports" element={<ReportPage />} />
          <Route path="reports/sales" element={<PermissionRoute permission="reports_sales"><SalesReportPage /></PermissionRoute>} />
          <Route path="reports/order-performance" element={<PermissionRoute permission="reports_orders"><OrderPerformancePage /></PermissionRoute>} />
          <Route path="reports/listing-performance" element={<PermissionRoute permission="reports_listing"><ListingPerformancePage /></PermissionRoute>} />
          <Route path="staff" element={<PermissionRoute permission="staff_view"><StaffManagementPage /></PermissionRoute>} />
          <Route path="staff/create" element={<PermissionRoute permission="staff_manage"><StaffFormPage mode="create" /></PermissionRoute>} />
          <Route path="staff/:staffType/:staffId/edit" element={<PermissionRoute permission="staff_view"><StaffFormPage mode="edit" /></PermissionRoute>} />
          <Route path="roles-permissions" element={<PermissionRoute permission="roles_manage"><RoleManagementPage /></PermissionRoute>} />
          <Route path="profile" element={<ProfilePage />} />
        </Route>

        <Route
          path="*"
          element={isMerchantAuthenticated() ? <Navigate to="/" /> : <Navigate to="/login" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
